module.exports = __webpack_public_path__ + "media/images/close-b4545f66216cb3d7a375b5069f52088a.png";